<template>
	<keep-alive :include="compKeepAlive">
		<router-view></router-view>
	</keep-alive>
</template>

<script>
	export default {
		name: 'Alive',

		data() {
			return {
				keepAlive: 'home',
				extendKeepAlive: []
			}
		},

		computed: {
			compKeepAlive() {
				return [this.keepAlive].concat(this.extendKeepAlive);
			}
		},

		watch: {
			$route: {
				handler(val) {
					if (val.meta.keepAlive && val.name) {
						this.keepAlive = val.name;
					}
					this.$nextTick(() => {
						this.exclude(val.name);
					});
				},
				immediate: true
			}
		},

		methods: {
			include(name, fun) {
				if (name && this.keepAlive != name && !this.extendKeepAlive.includes(name)) {
					this.extendKeepAlive.push(name);
					this.$nextTick(fun);
				} else {
					fun();
				}
			},

			exclude(name) {
				if (name && this.extendKeepAlive.includes(name)) {
					this.extendKeepAlive.splice(this.extendKeepAlive.findIndex(item => item == name), 1);
				}
			}
		}
	}
</script>

<style lang="stylus" scoped>
</style>